import React from "react";
import { useNavigate } from "react-router-dom";
import PropertyDataTableProvider from "./PropertyDataTable/Provider";

const PropertyData = () => {
  const navigate = useNavigate();

  return (
    <div className="h-[98vh] overflow-y-scroll">
      <div className="px-8 space-y-5">
        {/* HEADER */}
        <div className="flex justify-between items-center">
          <div>
            <h2>Asset Property Data</h2>
            <p>Manage Property Excel Data</p>
            <hr className="bg-[#FECE51] w-40 h-1" />
          </div>

          <button
            onClick={() => navigate("/admin/property-data/new")}
            className="bg-blue-600 text-white px-4 py-2 rounded-md"
          >
            Add Asset Property Data
          </button>
        </div>

        {/* TABLE */}
        <PropertyDataTableProvider />
      </div>
    </div>
  );
};

export default PropertyData;
